/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import { createTheme } from '@mui/material/styles';
import ThemeEnum from './enums/theme.enum';

const lightTheme = createTheme({
  typography: {
    fontFamily: '"DM Sans", system-ui',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: (themeOrProps) => {
          const theme = themeOrProps?.theme ?? themeOrProps;
          return {
          textTransform: 'none',
          // No transition on color: avoids flash when toggling disabled (toolbar Valida)
          transition: theme.transitions.create(
            ['background-color', 'box-shadow', 'border-color'],
            { duration: theme.transitions.duration.short }
          ),
          };
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#fff',
          color: 'rgba(0, 0, 0, 0.75)',
          fontSize: 12,
          fontWeight: 500,
          padding: '6px 10px',
          borderRadius: 6,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)',
          border: '1px solid rgba(0, 0, 0, 0.06)',
        },
        arrow: {
          color: '#fff',
          '&::before': {
            border: '1px solid rgba(0, 0, 0, 0.06)',
          },
        },
      },
    },
  },
  palette: {
    mode: ThemeEnum.LIGHT_MODE,
    primary: {
      main: '#1F76F1',
    },
    secondary: {
      main: '#21262D',
    },
    error: {
      main: '#ff4c51',
    },
    info: {
      main: '#d5d9e5',
      light: '#f3f3f3',
    },
    background: {
      default: '#F6F6F6',
      secondary: '#fff',
      contrast: '#a2a2a2'
    },
  },
});

export default lightTheme;
